import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { FormFieldDependentText } from '.';
import { TextDisplay } from '../Text/TextDisplay';
import { IDependentValue } from '@publishing-engine/domain/models/submission';

interface Props {
  value?: IDependentValue<string>;
  previousValue?: IDependentValue<string>;
  onClose: () => void;
  config: FormFieldDependentText;
}

export const DependentTextDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={4} backgroundColor="surfaceTertiaryFill">
      No data available
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Was value provided?</Text>
          <Text>{previousValue?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">Value </Text>
          {!previousValue?.value ? (
            zeroState
          ) : (
            <TextDisplay value={previousValue.value} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Was value provided?</Text>
          <Text>{value?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">Value </Text>
          {!value?.value ? zeroState : <TextDisplay value={value.value} />}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
